import { DataProvider } from 'assets/providers/data/DataProvider';
import ErrorPage from 'assets/templates/errorPage/ErrorPage';
import { HttpStatus, salesHomeRoute } from 'config/Api.Config';
import useContractRefund from './Sales.ContractRefund.Hooks';
import SalesContractRefundCancel from './sections/Sales.ContractRefund.Cancel';
import SalesContractRefundInfo from './sections/Sales.ContractRefund.Info';
import SalesContractRefundList from './sections/Sales.ContractRefund.List';
import SalesContractRefundProcess from './sections/process/Sales.ContractRefund.Process';
import SalesContractRefundProcessDealerPaymentControls from './sections/process/Sales.ContractRefund.Process.DealerPaymentControls';

export const salesContractRefundIndexRoute = salesHomeRoute + '/contractRefund/:action?/:id?';
export default function SalesContractRefundIndex() {
  const contractRefundHook = useContractRefund();

  if (!contractRefundHook.canView) return <ErrorPage status={HttpStatus.unauthorized} />;
  return (
    <>
      <DataProvider
        data={contractRefundHook}
        render={({ pageRouter }) => (
          <>
            {pageRouter.params?.id && pageRouter.params.action === 'info' ? (
              <SalesContractRefundInfo />
            ) : (
              <SalesContractRefundList />
            )}
            {pageRouter.params?.id && pageRouter.params.action === 'process' && <SalesContractRefundProcess />}
            {pageRouter.params?.id && pageRouter.params.action === 'dealerPaymentControls' && (
              <SalesContractRefundProcessDealerPaymentControls />
            )}
            {pageRouter.params?.id && pageRouter.params.action === 'cancel' && <SalesContractRefundCancel />}
          </>
        )}
      />
    </>
  );
}
